const base = 2; // decimal = 10, binario = 2; more info at: https://es.wikipedia.org/wiki/Byte
const powMultiplier = base === 10 ? 3 : 10;
const kilo = base ** powMultiplier;
const mega = base ** (powMultiplier * 2);
const giga = base ** (powMultiplier * 3);
const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

export const toFixedNoRounding = (number, decimals) => {
  const reg = new RegExp(`^-?\\d+(?:\\.\\d{0,${decimals}})?`, 'g');
  const a = number.toString().match(reg)[0];
  const dot = a.indexOf('.');
  if (dot === -1) {
    return `${a}.${'0'.repeat(decimals)}`;
  }
  const b = decimals - (a.length - dot) + 1;
  return b > 0 ? a + '0'.repeat(b) : a;
};

export const formatBytes = (bytes = 0, unit = 'B') => {
  if (bytes === 0) {
    return { size: 0, unit };
  }

  const pow = sizes.indexOf(unit.toUpperCase()) * powMultiplier;
  const floatSize = bytes / base ** pow;
  const intSize = Math.floor(floatSize);
  const hasDecimals = floatSize - intSize >= 0.01;
  const size = hasDecimals ? toFixedNoRounding(floatSize, 2) : intSize;

  return { size, unit };
};

export const byteToKb = b => formatBytes(b, 'KB');
export const byteToMb = b => formatBytes(b, 'MB');
export const byteToGb = b => formatBytes(b, 'GB');
export const kbToMb = kb => formatBytes(kb * kilo, 'MB');
export const kbToGb = kb => formatBytes(kb * kilo, 'GB');
export const mbToGb = mb => formatBytes(mb * mega, 'GB');

export const formatAmount = (value = 0, unit) => {
  const size = Number(value);
  const increaseKilo = size >= kilo;
  const increaseMega = size >= mega;
  const increaseGiga = size >= giga;

  switch (unit.toUpperCase()) {
    case 'B': {
      if (increaseGiga) {
        return byteToGb(size);
      }

      if (increaseMega) {
        return byteToMb(size);
      }

      if (increaseKilo) {
        return byteToKb(size);
      }

      return formatBytes(size, unit);
    }
    case 'KB': {
      if (increaseMega) {
        return kbToGb(size);
      }

      if (increaseKilo) {
        return kbToMb(size);
      }

      return formatBytes(size * kilo, unit);
    }
    case 'MB':
      return increaseKilo ? mbToGb(size) : formatBytes(size * mega, unit);
    case 'GB':
      return formatBytes(size * giga, 'GB');
    default:
      return { size, unit };
  }
};
